module.exports = __webpack_public_path__ + "files/7db40aa0a69b3d6298bad501b8dd274c.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-32x32.png
// module id = 1250
// module chunks = 76